import { useCallback, useEffect, useState } from "react";

const KEY = "wbm.trip.v1";
const EVT = "wbm-trip-change";

function read() {
  try {
    const raw = window.localStorage.getItem(KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function write(lines) {
  window.localStorage.setItem(KEY, JSON.stringify(lines));
  window.dispatchEvent(new Event(EVT));
}

/** Cart lines mirror the vendor order shape so Phase 4 needs no rewrite:
 *  each line owns its own charges (the order API takes Charges[] with
 *  {FeeID, LineNo}). */
export const useTrip = () => {
  const [lines, setLines] = useState(read);

  useEffect(() => {
    const sync = () => setLines(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const addLine = useCallback((line) => {
    const next = [...read(), { ...line, id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}` }];
    write(next);
    return next.length;
  }, []);

  const removeLine = useCallback((id) => {
    write(read().filter((l) => l.id !== id));
  }, []);

  const updateLine = useCallback((id, patch) => {
    write(read().map((l) => (l.id === id ? { ...l, ...patch } : l)));
  }, []);

  const clear = useCallback(() => write([]), []);

  return { lines, addLine, removeLine, updateLine, clear, count: lines.length };
};

export default useTrip;
